import { Amplify } from "aws-amplify";
import apiConfigOptions, { libraryOptions } from "../../api-config.js";
import CustomAuthStorage from "../../util/CustomAuthStorage.js";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { FORCED_AUTHENTICATION } from "../../util/constants.js";

const configureAmplify = async () => {
  const { customAuthStorage, ...apiConfig } = apiConfigOptions;
  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    new CustomAuthStorage(customAuthStorage)
  );

  const currentOrigin = window.location.origin;
  const redirectSignIn = `${currentOrigin}/login`;
  const redirectSignOut = `${currentOrigin}/logout`;
  const defaultOauth = {
    domain: process.env.REACT_APP_OAUTH_DOMAIN,
    scopes: ["openid", "profile", "aws.cognito.signin.user.admin"],
    redirectSignIn: [redirectSignIn],
    redirectSignOut: [redirectSignOut],
    responseType: 'code'
  };
  
  let config = {
    Auth: {
      Cognito: {
        loginWith: {
          oauth: defaultOauth,
        },
      },
    },
  };

  Object.assign(config, apiConfig);
  try {
    const awsExportsModule = await import("../../amplify_outputs.json");
    const { Auth: overrideAuth, API: overrideAPI, ...amplifyOutputs } = awsExportsModule.default || {};
    
    // Deep merge the configs, preserving our OAuth settings
    const preservedOauth = config.Auth.Cognito.loginWith.oauth;
    if (overrideAuth?.Cognito?.loginWith?.oauth) {
      const { Cognito: cognitoOverride } = overrideAuth;
      const { loginWith, ...rest } = cognitoOverride;
      Object.assign(config.Auth.Cognito, rest);
      const { oauth, ...restOfLoginWith } = cognitoOverride;
      Object.assign(config.Auth.Cognito.loginWith, restOfLoginWith);
      config.Auth.Cognito.loginWith.oauth = {
        ...cognitoOverride.loginWith.oauth,
        domain: preservedOauth.domain,
        scopes: preservedOauth.scopes,
        redirectSignIn: preservedOauth.redirectSignIn,
        redirectSignOut: preservedOauth.redirectSignOut,
        responseType: preservedOauth.responseType,
      };
    }
    config.Auth.Cognito.allowGuestAccess = !FORCED_AUTHENTICATION
    if(overrideAPI?.REST.endpoint) {
      config.API.REST = {
        default: overrideAPI.REST
      }
    }
    if(overrideAPI?.GraphQL.endpoint) {
      config.API.GraphQL = overrideAPI.GraphQL
    }
    Object.assign(config, amplifyOutputs);
  } catch (error) {
    console.error(
      "amplify_outputs.json not found, continuing with environment variables"
    );
  }
  Amplify.configure(config, libraryOptions);

  return Amplify.getConfig();
};

export default configureAmplify;
